import Vue from 'vue'
import App from './App.vue'
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router'
import NowUiKit from './plugins/now-ui-kit'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'
import '@/assets/scss/now-ui-kit.scss'
import * as VueGoogleMaps from 'vue2-google-maps'
import OtpInput from "@bachdgvn/vue-otp-input"
import '@/assets/scss/doodhvale.css'
import 'vueperslides/dist/vueperslides.css'
import VueFloatLabel from 'vue-float-label'

Vue.use(VueFloatLabel)
//import VueMaterial from 'vue-material'
//import { MdBottomBar, MdButton, MdIcon, MdCard, MdContent, MdRipple } from 'vue-material/dist/components'
//import 'vue-material/dist/vue-material.min.css'
//import 'vue-material/dist/theme/default.css'
Vue.component("v-otp-input", OtpInput)

/* Vue.use(MdBottomBar);
Vue.use(MdRipple);
Vue.use(MdContent);
Vue.use(MdCard);
Vue.use(MdIcon);
Vue.use(MdButton); */
Vue.config.productionTip = false;
//Vue.use(slideoutpanel);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    region: 'IN',
    language: 'en',
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
  installComponents: true

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});
//import VueGeolocation from 'vue-browser-geolocation'
//Vue.use(VueGeolocation)
Vue.use(NowUiKit);
Vue.use(VueSweetalert2);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
